import React, { Component } from 'react'
import Table from "../../../../components/UI/Table/Table";
// import './Table.css';
import { DEFAULT_PAGE_SIZE } from './constants';
import { Button } from 'reactstrap';
import moment from 'moment';
import '../style.scss';
import { BULK_QUICK_CASE, BULK_CASE, BULK_INTERNATIONAL_CASE } from '../constants';
let that;
const QUICK_REPORT_BULK_CASE_TABLE_COLUMN = [
    {
        Header: "Name",
        id: "corporateName",
        accessor: p => <p className="text-truncate" style={{ maxWidth: '150px' }}>{p.corporateName}</p>
    },
    {
        Header: "Created At",
        id: "createdAt",
        accessor: d => <div>{moment(d.createdAt).format('DD-MM-YYYY')}</div>
    },
    {
        Header: "Created By",
        id: "createdBy",
        // maxWidth: 100,
        accessor: p => <div>{p.createdBy}</div>,

    },
    {
        Header: "Status",
        id: "status",
        accessor: p => <Button className={(p.status === 'PARTIAL_FAILURE') ? 'btn btn-opacity mr-3 text-danger btn-opacity-danger download-link btn btn-link' : 'btn btn-opacity mr-3 text-success btn-opacity-success download-link btn btn-link'} onClick={() => that.downloadFailureFile(p)}>{p.status}</Button>,
        // className: 'status-column'
    },
    {
        Header: 'Action',
        id: 'action',
        accessor: p => <Button color='primary' onClick={() => that.openModal(p)}><i className="fa fa-ellipsis-h"></i></Button>
    },
    {
        Header: 'Crawler',
        id: 'crawler',
        accessor: p => <Button color='primary' onClick={() => that.downloadCrawlerStatus(p)}><i className="fa fa-download"></i></Button>
    },
    {
        Header: 'Summary',
        id: 'summary',
        accessor: p => <Button color='primary' onClick={() => that.downlodQuickReportSummary(p)}><i className="fa fa-download"></i></Button>
    }
];


const BULK_CASE_TABLE_COLUMN = [
    {
        Header: "Created At",
        id: "createdAt",
        accessor: d => <div>{moment(d.createdAt).format('DD-MM-YYYY')}</div>
    },
    {
        Header: "Created By",
        id: "createdBy",
        // maxWidth: 100,
        accessor: p => <div>{p.createdBy}</div>,

    },
    {
        Header: "Status",
        id: "status",
        accessor: p => <Button className={(p.status === 'PARTIAL_FAILURE' || p.status === 'FAILURE') ? 'btn btn-opacity mr-3 text-danger btn-opacity-danger download-link btn btn-link' : 'btn btn-opacity mr-3 text-success btn-opacity-success download-link btn btn-link'} onClick={() => that.downloadFailureFile(p)}>{p.status}</Button>,
        // className: 'status-column'
    },
    {
        Header: 'Action',
        id: 'action',
        accessor: p => <Button color='primary' onClick={() => that.handleOrignalFileDownload(p)}><i className="fa fa-download"></i></Button>
    }
];
class TableView extends Component {

    constructor(props) {
        super(props);
        this.state = {
            data: this.props.tasks,
            sorted: {
                id: "createdAt",
                desc: true
            },
            pageSize: DEFAULT_PAGE_SIZE,
            currentPageIndex: 0
        };
        that = this
    }

    
    componentDidUpdate(prevProps) {
        if (this.props.tasks !== prevProps.tasks) {
            this.setState({
                data: this.props.tasks
            } );
        }
    }
    
    downloadFailureFile = (data) => {
        if (data.status === 'PARTIAL_FAILURE' || data.status === 'FAILURE') {
            this.props.downloadFailedFile(data)
        } else {
            this.props.downloadOrignal(data)
        }
    }
    
    handleOrignalFileDownload = (data) => {
        this.props.downloadOrignal(data);
    }

    handleTableColumn =()=>{
        if(this.props.caseType === BULK_QUICK_CASE){
            return  QUICK_REPORT_BULK_CASE_TABLE_COLUMN;
        }
        if(this.props.caseType === BULK_CASE || this.props.caseType === BULK_INTERNATIONAL_CASE) {
            return BULK_CASE_TABLE_COLUMN;
        }

    }

    openModal = (data) => {
        this.setState({ quickCaseCreationRecordId : data.id})
        this.props.fetchProductDetail(data.productId, data.id, data.corporateName);
        this.props.toogleQuickReportModal()
    }

    downlodQuickReportSummary = (data) => {
        this.props.downlodQuickReportSummary({contractingEntityId : data.contractingEntityId, quickCaseCreationRecordId : data.id, name : data.corporateName })
    }

    downloadCrawlerStatus = (data) => {
        this.props.downloadCrawlerStatusFile({quickCaseCreationRecordId : data.id , name :  data.corporateName});
    }

    render() {
        return (
            <Table
                data={(this.state.data.recordList) ? this.state.data.recordList : []}
                columns={this.props.caseType === BULK_CASE ? BULK_CASE_TABLE_COLUMN : this.props.caseType === BULK_INTERNATIONAL_CASE ? BULK_CASE_TABLE_COLUMN : QUICK_REPORT_BULK_CASE_TABLE_COLUMN}
                defaultSorted={[
                    {
                        id: "createdAt",
                        desc: true
                    }
                ]}
                className=""
                noDataText="No Data found"
                multiSort={false}
                pages={this.state.data.numberOfPages}
                defaultPageSize={DEFAULT_PAGE_SIZE}
                showPagination={true}
                showPaginationTop={false}
                showPaginationBottom={true}
                manual  // this would indicate that server side pagination has been enabled 
                loading={this.props.loading}
                onPageChange={(pageIndex) => { // Called when the page index is changed by the user
                    this.setState({
                        currentPageIndex: pageIndex
                    });
                    this.props.onFetchPage({ pageNumber: pageIndex, pageSize: this.state.pageSize, sortField: this.state.sorted.id, sortDirection: (this.state.sorted.desc) ? 'desc' : 'asc', caseType:(this.props.caseType === BULK_INTERNATIONAL_CASE) ? 'INTERNATIONAL' : 'DOMESTIC'});
                }}
                onSortedChange={(newSorted, column, shiftKey) => { // Called when a sortable column header is clicked with the column itself and if the shiftkey was held. If the column is a pivoted column, 'column' will be an array of columns
                    this.setState({
                        sorted: newSorted[0]
                    });
                    this.props.onFetchPage({ pageNumber: 0, pageSize: this.state.pageSize, sortField: newSorted[0].id, sortDirection: (newSorted[0].desc) ? 'desc' : 'asc', caseType:(this.props.caseType === BULK_INTERNATIONAL_CASE) ? 'INTERNATIONAL' : 'DOMESTIC' });
                }}
                onPageSizeChange={(pageSize, pageIndex) => {
                    this.setState({
                        pageSize: pageSize
                    })
                    this.props.onFetchPage({ pageNumber: 0, pageSize: pageSize, sortField: this.state.sorted.id, sortDirection: (this.state.sorted.desc) ? 'desc' : 'asc', caseType:(this.props.caseType === BULK_INTERNATIONAL_CASE) ? 'INTERNATIONAL' : 'DOMESTIC' });
                }}
            />
        )
    }
}

export default TableView
